type HeroPlainProps = {
  title: string;
  children?: React.ReactNode;
};

export default function HeroPlain({
  title,
  children,
}: HeroPlainProps) {

  return (
    <div
      className="min-h-[500px] relative flex items-center bg-[#031B23] overflow-hidden"
    >
      <div className='max-w-1280 w-full mx-auto mt-20 px-20 desktopSmall:px-40 text-center'>
        <div className="w-full mx-auto relative ipad:max-w-540">
          <h1 className="text-title2 desktopSmall:text-title1 text-white mb-16 mt-32 font-medium">
            {title}
          </h1>

          {children ? children : null}
        </div>
      </div>
    </div>
  )
};
